import { render, staticRenderFns } from "./PriceMatchClaimModal.vue?vue&type=template&id=710652c6&scoped=true"
import script from "./PriceMatchClaimModal.vue?vue&type=script&lang=js"
export * from "./PriceMatchClaimModal.vue?vue&type=script&lang=js"
import style0 from "./PriceMatchClaimModal.vue?vue&type=style&index=0&id=710652c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710652c6",
  null
  
)

export default component.exports